<template>
  <b-card id="page-template" no-body class="mb-0">
    <b-card-header>
      <b-card-title>
        <h2>
          {{ $t("pages.templates.title").toLowerCase() }}
          <!-- Creador de Plantillas de WhatsApp -->
        </h2>
      </b-card-title>
    </b-card-header>

    <b-card-body>
      <b-form>
        <b-row>
          <!-- Nombre de la Plantilla -->
          <b-col cols="12" md="6">
            <b-form-group :label="$t(label('name'))" label-for="template-name">
              <b-form-input
                id="template-name"
                v-model="template.name"
                placeholder="ej: confirmacion_pedido_v2 (solo minúsculas y _)"
              />
            </b-form-group>
          </b-col>

          <!-- Categoría -->
          <b-col cols="12" md="6">
            <b-form-group
              :label="$t(label('category'))"
              label-for="template-category"
            >
              <v-select
                v-model="template.category"
                input-id="template-category"
                :options="categoryOptions"
                label="text"
                :reduce="(option) => option.value"
              />
            </b-form-group>
          </b-col>

          <!-- Encabezado de la Plantilla -->
          <b-col cols="12" md="6">
            <b-form-group :label="$t(label('header'))" label-for="header-text">
              <b-form-input
                id="header-text"
                v-model="headerText"
                placeholder="Texto que aparecerá en negrita arriba"
              />
            </b-form-group>
          </b-col>

          <!-- Cuerpo del Mensaje -->
          <b-col cols="12">
            <b-form-group :label="$t(label('body'))" label-for="body-text">
              <b-form-textarea
                id="body-text"
                v-model="bodyText"
                rows="5"
                :placeholder="`Hola {{1}}, gracias por tu compra. Tu pedido #{{2}} está siendo preparado.`"
              />
              <b-button variant="primary" class="mt-1" @click="insertVariable">
                Insertar Variable: <strong>{{ `${nextVar}` }}</strong>
              </b-button>
            </b-form-group>
          </b-col>

          <!-- Botones de Respuesta Rápida -->
          <b-col cols="12">
            <b-form-group :label="$t(label('details'))">
              <div
                v-for="(btn, index) in quickReplyButtons"
                :key="index"
                class="d-flex align-items-center mb-1"
              >
                <b-form-input
                  v-model="btn.text"
                  :placeholder="`Texto del botón ${index + 1}`"
                  class="mr-2"
                />
                <b-button
                  variant="danger"
                  @click="removeButton(index)"
                  class="remove-btn"
                >
                  <feather-icon icon="XIcon" />
                </b-button>
              </div>
              <b-button
                variant="primary"
                @click="addButton"
                :disabled="quickReplyButtons.length >= 3"
              >
                Añadir botón
              </b-button>
            </b-form-group>
          </b-col>
          <!-- Panel de vista previa -->
          <b-col cols="12" lg="6">
            <div class="preview-container">
              <h4 class="mb-1 mt-2">Vista Previa</h4>
              <div class="phone-mockup">
                <div class="whatsapp-header">
                  <span class="contact-name">Cliente Ejemplo</span>
                </div>
                <div class="chat-area">
                  <div class="whatsapp-bubble">
                    <div v-if="headerText" class="preview-header">
                      {{ headerText }}
                    </div>
                    <div class="preview-body" v-html="previewBody"></div>
                    <div class="preview-footer">Tu empresa</div>
                  </div>
                  <div
                    v-if="quickReplyButtons.length > 0"
                    class="preview-buttons"
                  >
                    <div
                      v-for="(btn, index) in quickReplyButtons"
                      :key="index"
                      class="preview-button"
                    >
                      {{ btn.text || `Botón ${index + 1}` }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-col>
          <!-- Botón de envío -->
          <b-col
            class="d-flex justify-content-end align-items-center"
            cols="12"
          >
            <b-button
              :disabled="isLoading"
              type="submit"
              variant="primary"
              class="mr-1"
              @click.prevent="onSubmit"
            >
              {{ $t("save") }}
              <b-spinner small v-if="isLoading"></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card-body>
  </b-card>
</template>

<script>
import vSelect from "vue-select";
import {
  BInputGroup,
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BFormGroup,
  BFormCheckbox,
  BForm,
  BFormTextarea,
  BToast,
  BMedia,
  BFormInvalidFeedback,
  BSpinner,
  BAlert,
} from "bootstrap-vue";
import { createTemplate } from "@core/api/request/template";
import { showLoading, stopLoading } from "@core/utils/utils";

export default {
  components: {
    BSpinner,
    BAlert,
    BInputGroup,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormGroup,
    BFormCheckbox,
    BForm,
    BFormTextarea,
    BToast,
    BMedia,
    BFormInvalidFeedback,
    vSelect,
  },
  data() {
    return {
      isLoading: false,
      apiResponse: "",
      isError: false,
      nextVar: 1,
      categoryOptions: [
        {
          text: "Utilidad (Confirmaciones, actualizaciones, etc.)",
          value: "UTILITY",
        },
        {
          text: "Marketing (Promociones, anuncios, etc.)",
          value: "MARKETING",
        },
        {
          text: "Autenticación (Códigos de un solo uso)",
          value: "AUTHENTICATION",
        },
      ],
      headerText: "",
      template: {
        name: "",
        category: "UTILITY",
        language: "es",
      },
      bodyText: "",
      quickReplyButtons: [],
    };
  },
  computed: {
    previewBody() {
      // Reemplaza las variables {{n}} con texto de ejemplo para la vista previa
      return this.bodyText
        .replace(/\n/g, "<br>")
        .replace(
          /\{\{(\d+)\}\}/g,
          '<span class="variable-tag">[Variable $1]</span>',
        );
    },
  },
  methods: {
    label(field) {
      return `pages.templates.form.label.${field}`;
    },
    insertVariable() {
      this.bodyText += `{{${this.nextVar}}}`;
      this.nextVar++;
    },
    addButton() {
      if (this.quickReplyButtons.length < 3) {
        this.quickReplyButtons.push({ text: "" });
      }
    },
    removeButton(index) {
      this.quickReplyButtons.splice(index, 1);
    },

    onSubmit() {
      // this.$refs.simpleRules.validate().then((success) => {
      //   if (success) {
      this.isLoading = true;
      showLoading();
      let components = [];

      if (this.headerText) {
        components.push({
          type: "HEADER",
          format: "TEXT",
          text: this.headerText,
        });
      }

      components.push({
        type: "BODY",
        text: this.bodyText,
      });

      if (this.quickReplyButtons.filter((b) => b.text).length > 0) {
        components.push({
          type: "BUTTONS",
          buttons: this.quickReplyButtons
            .filter((b) => b.text)
            .map((btn) => ({ type: "QUICK_REPLY", text: btn.text })),
        });
      }

      const payload = {
        name: this.template.name,
        language: this.template.language,
        category: this.template.category,
        components: components,
      };

      createTemplate(payload)
        .then(() => {
          stopLoading();
          this.isLoading = false;
          this.alertToast("success", "Registro exitoso");
        })
        .catch((error) => {
          console.log("error", error);
          stopLoading();
          this.isLoading = false;
          this.alertToast("danger", "Alerta error", error.message);
        });
      // }
      // });
    },

    alertToast(type = null, title = null, message = null) {
      this.$bvToast.toast(message, {
        title,
        variant: type,
        solid: true,
        icon: "CoffeeIcon",
      });
    },
    // async onSubmit() {
    //   this.isLoading = true;
    //   this.apiResponse = "";
    //   this.isError = false;

    //   const payload = {
    //     name: this.template.name,
    //     language: this.template.language,
    //     category: this.template.category,
    //     components: [
    //       {
    //         type: "BODY",
    //         text: this.bodyText,
    //       },
    //     ],
    //   };

    //   if (this.quickReplyButtons.length > 0) {
    //     payload.components.push({
    //       type: "BUTTONS",
    //       buttons: this.quickReplyButtons.map((btn) => ({
    //         type: "QUICK_REPLY",
    //         text: btn.text,
    //       })),
    //     });
    //   }

    //   try {
    //     const response = await axios.post(
    //       "/api/whatsapp/templates/create",
    //       payload
    //     );
    //     this.apiResponse = response.data.message;
    //   } catch (error) {
    //     this.isError = true;
    //     this.apiResponse =
    //       "Error: " + (error.response?.data?.message || error.message);
    //   } finally {
    //     this.isLoading = false;
    //   }
    // },
  },
};
</script>

<style lang="scss" scoped>
.template-builder {
  max-width: 800px;
  margin: 0 auto;
}

.remove-btn {
  min-width: 38px;
}

.submit-btn {
  background-color: #25d366;
  border-color: #25d366;

  &:disabled {
    opacity: 0.65;
  }
}

.v-select {
  width: 100%;
}
</style>
